// test1483
(1483 && 0);
